import { profileStoreUser } from '@/shared/lib/domains/profile/profileStoreUser';
import { cardDataNumber } from '@/shared/lib/domains/card/cardDataNumber';
import { cardDataHash } from '@/shared/lib/domains/card/cardDataHash';

/**
 * Композиция получения данных о карте
 * зависит от текущего юзера
 */
export function cardSetupProperties() {
  const user = profileStoreUser();

  return {
    number: cardDataNumber(user),
    hash: cardDataHash(user),
  };
}
